export function fixGetManyMessages(json) {
    return {
        data: json.map((resource) => ({
            ...resource,
            id: resource.objectId,
            messageId: resource.objectId,
        })),
    };
}

export function messageMapperListResponse(json, headers) {
    return {
        data: json.map((resource) => ({
            ...resource,
            id: resource.objectId,
            messageId: resource.objectId,
        })),
        total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
    };
}